export const extractEntityName = (entityId) => {
    const parsedEntityId = JSON.parse(entityId);
    const keys = Object.keys(parsedEntityId);
    return keys.length ? keys[0].split(".")[0].replace("CDM_", "") : "";
};

export function hasJsonStructure(str) {
    if (typeof str !== "string") return false;
    try {
        const result = JSON.parse(str);
        const type = Object.prototype.toString.call(result);
        return type === "[object Object]" || type === "[object Array]";
    } catch (err) {
        return false;
    }
}
